var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-bottom":"4rem"},attrs:{"id":"app"}},[(_vm.userLoggedInStatus && _vm.showNav)?_c('main-nav'):_vm._e(),_c('router-view',{staticStyle:{"margin-top":"40px"}}),_c('alert-alert')],1)}
var staticRenderFns = []

export { render, staticRenderFns }